import { configureStore } from '@reduxjs/toolkit';
import loginReducer from './slice/login';
//import {step} from "./slice/login";
import walletReducer from './slice/wallet';
import transactionReducer from './slice/transaction';
import debtsReducer from './slice/debts';
import swichComponent from './slice/swich';
import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
// import persistStore from 'redux-persist/es/persistStore';
import storeSlice from './slice/stores';
import wallet6MonthsSlice from './slice/wallet-6months';
import walletRequestOne from './slice/walletRequestStepOne';
import walletRequestTwo from './slice/walletRequestStepTwo';
import connection from './slice/connection';
import promissoryNote from './slice/promissoryNote';
import _createStoreSlice from './slice/New/stores';
import HomeWalletSlice from './slice/home';
import _createMehrSlice from './slice/New/mehr';

const rootPersistConfig = {
	key: 'root',
	storage,
	blacklist: [
		'login',
		'debts',
		'wallet6MonthsSlice',
		'walletRequestOne',
		'walletRequestTwo',
		'HomeWalletSlice',
		'stores',
		'transaction',
		'storeSlice',
		'_createMehrSlice',
		'mehr',
	],
};
const authPersistConfig = {
	key: 'login',
	storage,
	blacklist: ['step', 'mehr'],
};
const wallet6MonthsConfig = {
	key: 'wallet6months',
	storage,
	whitelist: ['walletRequestID', 'cashPayFee'],
};
const walletRequestConfig = {
	key: 'walletReq',
	storage,
	whitelist: ['walletRequestID', 'cashPayFee'],
};
const storePersistConfig = {
	key: 'storeSlice',
	storage,
	blacklist: ['storesListByCats'],
};

const rootReducer = combineReducers({
	login: persistReducer(authPersistConfig, loginReducer),
	transaction: transactionReducer,
	swichComponent,
	wallet: walletReducer,
	walletRequestOne: persistReducer(walletRequestConfig, walletRequestOne),
	walletRequestTwo,
	storeSlice: persistReducer(storePersistConfig, storeSlice),
	stores: _createStoreSlice,
	debts: debtsReducer,
	wallet6MonthsSlice: persistReducer(wallet6MonthsConfig, wallet6MonthsSlice),
	connection,
	promissoryNote,
	HomeWalletSlice,
	mehr: _createMehrSlice,
});

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

const store = configureStore({
	devTools: process.env.NODE_ENV !== 'production',
	reducer: persistedReducer,
});

const persistor = persistStore(store);

export { persistor, store };
